import { AbstractControl, UntypedFormArray, UntypedFormControl } from '@angular/forms';

import { ErrorResponse } from '../entities/errors-response.entity';

export const IsControlInvalid: (
    control: UntypedFormControl | UntypedFormArray,
    errorResponse: ErrorResponse
) => boolean = (control: UntypedFormControl | UntypedFormArray, errorResponse: ErrorResponse): boolean => {
    if (control) {
        let controlToCheck: AbstractControl = control;
        if (control.parent && control.parent.validator) {
            controlToCheck = control.parent;
        }
        const invalidity: boolean = control.invalid;
        let limiter = true;
        if (errorResponse === ErrorResponse.TOUCHED) {
            limiter = controlToCheck.touched;
        } else if (errorResponse === ErrorResponse.DIRTY) {
            limiter = controlToCheck.dirty;
        }
        return invalidity && limiter;
    } else {
        return false;
    }
};
